import { useTranslation } from 'react-i18next';
import ArticleCard from '../compnents/cards/ArticleCard';
import Sidebar from '../compnents/Sidebar';

const Article = () => {
	const { t } = useTranslation();
	const articles = [
		{
			title: 'Whisper',
			description:
				'التعرف التلقائي على الكلام (ASR) باستخدام Whisper من OpenAI...',
			image: '/images/about.png',
		},
		{
			title: 'MCTS',
			description: 'مقدمة عن Monte Carlo Tree Search (MCTS)...',
			image: '/images/about.png',
		},
		{
			title: 'BERT',
			description: 'دليل مُفصل لـ BERT: نموذج NLP الأقوى...',
			image: '/images/about.png',
		},
		{
			title: 'Imbalanced Data',
			description: 'كيفية التعامل مع مشكلة البيانات غير المتوازنة...',
			image: '/images/about.png',
		},
	];
	return (
		<div className='mt-20'>
			<section className='bg-main h-[35vh] md:h-[50vh] flex justify-center items-center mb-16'>
				<h2 className='text-2xl md:text-5xl text-white font-semibold'>
					{t('article')}
				</h2>
			</section>

			<main className='min-h-screen bg-gray-50 text-black px-6 py-10'>
				<h1 className='text-center text-blue-700 text-3xl font-bold mb-10'>
					المقالات
				</h1>
				<div className='flex flex-col lg:flex-row gap-8'>
					{/* المقالات */}
					<div className='grid grid-cols-1 md:grid-cols-2 gap-6 flex-1'>
						{articles.map((article, index) => (
							<ArticleCard
								key={index}
								title={article.title}
								description={article.description}
								image={article.image}
							/>
						))}
					</div>

					{/* الشريط الجانبي */}
					<Sidebar />
				</div>
			</main>
		</div>
	);
};

export default Article;
